module.exports = __webpack_public_path__ + "img/demo2.ed305281.jpg";